export const NOTIFICATIONS_PERMISSION = "notification:read"

export const UPDATE_NOTIFICATIONS_PERMISSION = "notification:update"
